export default __webpack_public_path__ + "img/ng100.057ea5b4.jpg";